import { render } from "./vcommonproblemedit.vue?vue&type=template&id=6c669682&scoped=true"
import script from "./vcommonproblemedit.vue?vue&type=script&lang=js"
export * from "./vcommonproblemedit.vue?vue&type=script&lang=js"

import "./vcommonproblemedit.vue?vue&type=style&index=0&id=6c669682&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c669682"]])

export default __exports__